"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgressStepperStepLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ProgressStepperStepLabelMixin = require("../../mixins/components/ProgressStepperStepLabelMixin");
var StyledProgressStepperStepLabel = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledProgressStepperStepLabel",
  componentId: "c11n-8-107-0__sc-y06vu6-0"
})(["", ""], _ProgressStepperStepLabelMixin.ProgressStepperStepLabelMixin);
exports.StyledProgressStepperStepLabel = StyledProgressStepperStepLabel;